module.exports = __webpack_public_path__ + "assets/img/勿扰模式.4d638172.png";